import { createSlice } from "@reduxjs/toolkit";

const getWidgetPosition = () => {
  const data = localStorage.getItem("widgetPosition");
  return data ? JSON.parse(data) : null;
};

const initialState = {
  moveWidget: getWidgetPosition(),
};

const movewidgetSlice = createSlice({
  name: "movewidget",
  initialState,
  reducers: {
    setMoveWidget(state, action) {
      state.moveWidget = action.payload;
      localStorage.setItem("widgetPosition", JSON.stringify(action.payload));
    },
  },
});

export const { setMoveWidget } = movewidgetSlice.actions;

export default movewidgetSlice.reducer;
